import React, { useRef, useEffect, useState } from "react";
import Layout from "./Layout";
import { COLLECTION, SESSION } from "../../../data/constant";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  runTransaction,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import axios from "axios";
import { createInitialForm } from "../../../common/common";
import { walletData } from "../../../assets/lib/wallet";
import { useNavigate } from "react-router-dom";


const Wallet = () => {
  const [walletAmount, setWalletAmount] = useState("");
  const [walletState, setWalletState] = useState(createInitialForm(walletData));
  const [rechargeLoader, setRechargeLoader] = useState(false);

  // New states
  const [friendNumber, setFriendNumber] = useState("");
  const [friendName, setFriendName] = useState("");
  const [friendId, setFriendId] = useState("");
  const [verifyStatus, setVerifyStatus] = useState(null);
  const [sendAmount, setSendAmount] = useState("");
  const [transferLoader, setTransferLoader] = useState(false);
  const [transferMessage, setTransferMessage] = useState("");

  // Offer states
  const [offers, setOffers] = useState([]);
  const [offersModalOpen, setOffersModalOpen] = useState(false);

  // Recharge status
  const [rechargeStatusMessage, setRechargeStatusMessage] = useState("");

  const [emailOptOut, setEmailOptOut] = useState(false);
  const [subscribeLoading, setSubscribeLoading] = useState(false);

  const userId = useRef("");
  const phoneNumber = useRef("");
  const navigate = useNavigate();

  // ✅ Fetch wallet balance
  const getWalletAmount = async () => {
    const sessionId = localStorage.getItem(SESSION.USER_SESSION_ID);
    const docRef = doc(db, COLLECTION.USER_SESSION, sessionId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      userId.current = data.userID;
      phoneNumber.current = data.phoneNumber;
    }

    const userDocRef = doc(db, COLLECTION.USER, userId.current);
    const userDocSnap = await getDoc(userDocRef);
    if (userDocSnap.exists()) {
      const userData = userDocSnap.data();
      setWalletAmount(userData.walletAmount);
      setEmailOptOut(userData.emailOptOut === true);

    }
  };

  // Input handler
  const getWalletInput = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    const inputType = event.target.type;
    if (value && inputType === "number") {
      value = parseInt(value);
    }
    setWalletState((prevState) => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    getWalletAmount();
  }, []);

// Razorpay Checkout Integration
const handleRecharge = async () => {
  if (!walletState.rechargeAmount || walletState.rechargeAmount <= 0) return;

  try {
    setRechargeLoader(true);
    console.log("🚀 Creating Razorpay order...");

    // Call your Cloud Function to create order
    const response = await axios.post(
      "https://razorpay-pay-713732302795.asia-south1.run.app",
      {
        userId: userId.current,
        amount: walletState.rechargeAmount,
        mobileNumber: phoneNumber.current,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    const { order_id, key, transactionId, amount } = response.data;
    console.log("🧾 Razorpay order received:", response.data);

    const options = {
      key: key, // Razorpay Key
      amount: amount * 100, // in paise
      currency: "INR",
      name: "AlpaaGo Wallet Recharge",
      description: "Wallet Recharge",
      order_id: order_id,
      prefill: { contact: phoneNumber.current },
      handler: async function (paymentResponse) {
        console.log("💳 Payment response:", paymentResponse);

        // Send payment details to verification Cloud Function
        const verifyResp = await axios.post(
          "https://razorpay-verify-713732302795.asia-south1.run.app",
          {
            razorpay_payment_id: paymentResponse.razorpay_payment_id,
            razorpay_order_id: paymentResponse.razorpay_order_id,
            razorpay_signature: paymentResponse.razorpay_signature,
            transactionId: transactionId,
          },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("✅ Verification response:", verifyResp.data);

        // Refresh wallet
        await getWalletAmount();

        // Redirect frontend after all processing is done
        if (verifyResp.data.redirectUrl) {
          window.location.href = verifyResp.data.redirectUrl;
        }
      },
      theme: { color: "#000000" },
    };

    // Open Razorpay Checkout
    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error("Recharge Error:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setRechargeLoader(false);
  }
};


  // ✅ Friend verification & transfer (unchanged)
  const verifyFriend = async () => {
    setVerifyStatus(null);
    setFriendName("");
    setFriendId("");
    setTransferMessage("");

    if (!friendNumber) {
      setTransferMessage("Please enter a phone number");
      return;
    }
    if (parseInt(friendNumber) === phoneNumber.current) {
      setTransferMessage("You cannot send money to yourself");
      return;
    }

    try {
      const parsedNumber = parseInt(friendNumber.trim());
      const q = query(
        collection(db, COLLECTION.USER),
        where("phoneNumber", "==", parsedNumber)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const docData = querySnapshot.docs[0].data();
        setFriendName(docData.userName || "Unknown");
        setFriendId(querySnapshot.docs[0].id);
        setVerifyStatus("success");
      } else {
        setVerifyStatus("error");
      }
    } catch (err) {
      setTransferMessage("Error verifying number");
    }
  };

  const sendMoney = async () => {
    const amount = parseInt(sendAmount);
    if (!amount || amount <= 0) {
      setTransferMessage("Please enter a valid amount");
      return;
    }
    if (amount > walletAmount) {
      setTransferMessage("Insufficient balance");
      return;
    }

    setTransferLoader(true);
    try {
      await runTransaction(db, async (transaction) => {
        const senderRef = doc(db, COLLECTION.USER, userId.current);
        const friendRef = doc(db, COLLECTION.USER, friendId);
        const senderDoc = await transaction.get(senderRef);
        const friendDoc = await transaction.get(friendRef);

        if (!senderDoc.exists() || !friendDoc.exists()) {
          throw new Error("User not found");
        }

        const senderBalance = senderDoc.data().walletAmount;
        if (senderBalance < amount) throw new Error("Insufficient balance");

        transaction.update(senderRef, {
          walletAmount: senderBalance - amount,
        });
        transaction.update(friendRef, {
          walletAmount: friendDoc.data().walletAmount + amount,
        });
      });

      setTransferMessage("Money sent successfully!");
      setTimeout(() => setTransferMessage(""), 3000);
      setSendAmount("");
      setVerifyStatus(null);
      setFriendName("");
      setFriendNumber("");
      getWalletAmount();
    } catch (err) {
      setTransferMessage(err.message || "Transaction failed");
    } finally {
      setTransferLoader(false);
    }
  };

  // ✅ Fetch offers (unchanged)
  const fetchOffers = async () => {
    try {
      const q = query(collection(db, "RechargeOffers"));
      const querySnapshot = await getDocs(q);
      const today = new Date().toISOString().split("T")[0];
      const validOffers = [];
      querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        let expiry = data.endDate;
        if (expiry?.toDate) expiry = expiry.toDate().toISOString().split("T")[0];
        if (expiry >= today) {
          validOffers.push({ id: docSnap.id, ...data, endDate: expiry });
        }
      });
      setOffers(validOffers);
      setOffersModalOpen(true);
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };

  const applyOffer = (offer) => {
    setWalletState((prev) => ({
      ...prev,
      rechargeAmount: offer.rechargeAmount,
    }));
    setOffersModalOpen(false);
  };

  // ✅ Verify recharge status (unchanged)
  const verifyRecharge = async () => {
    try {
      const q = query(
        collection(db, COLLECTION.RECHARGES),
        where("userID", "==", userId.current)
      );
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        setRechargeStatusMessage("No recharge records found");
        setTimeout(() => setRechargeStatusMessage(""), 5000);
        return;
      }

      const latestDoc = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => b.transactiontime.toMillis() - a.transactiontime.toMillis())[0];

      if (!latestDoc.message) {
        await axios.post("https://verify-razorpay-recharge-713732302795.asia-south1.run.app", {
          transactionId: latestDoc.id,
        });
        window.location.reload();
      } else {
        setRechargeStatusMessage("Recharges are up to date");
        setTimeout(() => setRechargeStatusMessage(""), 5000);
      }
    } catch (error) {
      setRechargeStatusMessage("Something went wrong. Try again.");
      setTimeout(() => setRechargeStatusMessage(""), 5000);
    }
  };

  const handleNewsletterToggle = async () => {
  if (!emailOptOut) return;

  setSubscribeLoading(true);
  try {
    const userRef = doc(db, COLLECTION.USER, userId.current);

    await runTransaction(db, async (transaction) => {
      transaction.update(userRef, { emailOptOut: false });
    });

    setEmailOptOut(false);
  } catch (err) {
    console.error("Newsletter subscribe failed:", err);
    alert("Failed to subscribe. Please try again.");
  } finally {
    setSubscribeLoading(false);
  }
};


  return (
    <Layout
      walletAmount={walletAmount}
      handle={handleRecharge} // Razorpay recharge
      getWalletInput={getWalletInput}
      walletState={walletState}
      rechargeLoader={rechargeLoader}
      friendNumber={friendNumber}
      setFriendNumber={setFriendNumber}
      friendName={friendName}
      verifyStatus={verifyStatus}
      verifyFriend={verifyFriend}
      sendAmount={sendAmount}
      setSendAmount={setSendAmount}
      sendMoney={sendMoney}
      transferLoader={transferLoader}
      transferMessage={transferMessage}
      fetchOffers={fetchOffers}
      offers={offers}
      offersModalOpen={offersModalOpen}
      setOffersModalOpen={setOffersModalOpen}
      applyOffer={applyOffer}
      verifyRecharge={verifyRecharge}
      rechargeStatusMessage={rechargeStatusMessage}

      emailOptOut={emailOptOut}
      handleNewsletterToggle={handleNewsletterToggle}
      subscribeLoading={subscribeLoading}

    />
  );
};

export default Wallet;
